import React from 'react';
import '../view/sass/App.scss';
import { InterfaceProvider } from '../model/InterfaceProvider';
import { MapProvider } from './MapProvider';
import { debugMode } from '../model/StaticVariables';
import Interface from '../view/Interface';
import { isIE } from './IfIE';
require('ol/ol.css');

//check if IE and if not remove fallback
if (!isIE()) {
    document.getElementById('iefallback')?.remove();
}
document.body.classList.remove('dynamic-loading'); //remove spinner added from embed code

function App() {
    return (
        <div role="application" aria-label="Social Vulnerability Index Interactive Map" className={`svi_interactive_map embed ${debugMode ? 'debugMode' : ''}`}>
            <InterfaceProvider>
                <MapProvider>
                    <Interface />
                </MapProvider>
            </InterfaceProvider>
        </div>
    );
}
export default App;
